import { appConfig } from './config/app-config.instance'
import { type TagInterface } from 'data-access/market/type/market-tag-type'
import { dataAccessTags } from 'data-access/market/data-access-tags'

export class Tags {
  private data: TagInterface[]
  private isInitialized: boolean
  private isLoading: boolean

  constructor () {
    this.data = []
    this.isInitialized = false
    this.isLoading = false
  }

  private async initialize (): Promise<void> {
    if (!this.isInitialized && !this.isLoading) {
      this.isLoading = true
      try {
        await appConfig.waitForLoad()
        this.data = await dataAccessTags.getTags()
        this.isInitialized = true
      } finally {
        this.isLoading = false
      }
    }
  }

  get fetchedData (): TagInterface[] {
    if (!this.isInitialized) {
      void this.initialize()
    }
    return this.data
  }

  get loading (): boolean {
    return this.isLoading
  }
}

export const marketTags = new Tags()
